export const CASE_STATUS_MAP: { [key: string]: string } = {
  created: "requested",
  assigned: "active",
  approved: "active",
  support: "active",
  waiting: "active",
  processing: "active",
  completed: "completed",
  canceled: "completed",
  cancelled: "completed",
};
